import { Button, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { X } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	title: string;
	description: string;
	buttonLabel: string;
	isPending?: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

export const ContactAgentDialogContactStep: FC<Props> = ({
	title,
	description,
	buttonLabel,
	isPending,
	onClose,
	onConfirm,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack>
			<Stack
				direction="row"
				alignItems="flex-start"
				justifyContent="space-between"
				gap={theme.spacingTokens.md}
			>
				<Typography variant="h3" component="h2">
					{title}
				</Typography>
				<IconButton
					variant="ghost"
					aria-label={t(Resources.Common.Cancel)}
					onClick={onClose}
					sx={{
						width: theme.dialog.closeButtonSize,
						height: theme.dialog.closeButtonSize,
						p: 0,
					}}
				>
					<X size={theme.iconSize.md} color={theme.palette.grey[500]} />
				</IconButton>
			</Stack>
			<Typography variant="body2" mt={theme.spacingTokens.md}>
				{description}
			</Typography>
			<Button
				variant="primary"
				loading={isPending}
				onClick={onConfirm}
				sx={{ mt: theme.spacingTokens.xl }}
			>
				{buttonLabel}
			</Button>
		</Stack>
	);
};
